<template>
    <div class="history d-flex-c-ast-jfs-gap15">
        <h2 class="p-30">تاریخچه</h2>
        <trades/>
        <transactions/>
        <login/>
    </div>
</template>

<script>
    import Transactions from "@/components/Panel/History/Transactions";
    import Trades from "@/components/Panel/History/Trades";
    import Login from "@/components/Panel/History/Login";
    export default {
        name: "History",
        components: {Login, Trades, Transactions}
    }
</script>

<style lang="scss" scoped>
    .history {
        padding: 0 20px 20px;
        text-align: right;

    }

</style>